export const Constants = {
    NumberOfDaysAllowEditAfterApprove: 7,
    NumberOfDaysDisplayFormAfterApprove: 2,

    FormsCacheKey: "FORMS",
    FormsCountCacheKey: "FORMS_COUNT",
    ModifiedDateCacheKey: "MODIFIED_DATE"
  };
